module.exports = __webpack_public_path__ + "img/LewisLanier.20d82297.png";